"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function NotificationsList(_a) {
    var notifications = _a.notifications, setNotifications = _a.setNotifications, user = _a.user;
    var _b = ra_fetch_1.useApi('backend')
        .records(setNotifications, notifications.data, 'id', 'id')
        .delete('notifications', { id: user.id }), deleteNotification = _b[0], submitDeleteNotification = _b[1];
    if (!notifications.data.length) {
        return react_1.default.createElement(storybook_1.Texts.Small, { className: 'storybook-users-notifications-nothing' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'inbox', className: 'w-12 inline-block mb-2' }),
            react_1.default.createElement("span", { className: 'block' }, "Er zijn geen nieuwe berichten"));
    }
    return react_1.default.createElement("ul", null, notifications.data.map(function (notification, index) {
        return react_1.default.createElement("li", { key: index, className: 'py-4 border-b border-gray-300 flex items-center' },
            react_1.default.createElement("a", { href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + notification.url, className: 'notification flex items-center w-full cursor-pointer', onClick: function () { return submitDeleteNotification({ id: notification.id }); }, target: '_blank' },
                react_1.default.createElement(storybook_1.Notifications.Image, { src: notification.channel.logo, alt: notification.channel.name }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4', className: 'block mb-2' }, notification.title),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Check de nieuwe video van ",
                        notification.channel.name),
                    react_1.default.createElement(storybook_1.Texts.Small, { className: 'block text-dark' }, storybook_1.Helpers.uploadTime(notification.created_at)))),
            react_1.default.createElement(storybook_1.Buttons.Button, { icon: 'trash', onClick: function () { return submitDeleteNotification({ id: notification.id }); } }));
    }));
}
exports.default = NotificationsList;
